import React from 'react';
import { ContentBgLayout } from 'layout';
import { DossierConsents } from 'pods/dossier/consents';
export const DossierConsentsScene = () => {
    return (React.createElement(ContentBgLayout, null,
        React.createElement(DossierConsents, null)));
};
